import { ApiError } from 'src/api/generated';
import {
  HTTP_STATUS_FORBIDDEN,
  HTTP_STATUS_UNAUTHORIZED,
} from '../../constants/api/api.constants';
import type { ApiQueryMeta } from '../../types/api/api-query-meta.type';

/**
 * Identifies queries whose caller handles terminal errors.
 * @param meta - The query's metadata.
 * @returns Whether the global query error callback should be skipped.
 */
export const isCallerHandledQueryError = (
  meta: ApiQueryMeta | undefined
): boolean => meta?.errorHandling === 'caller';

/**
 * Recognizes authorization failures without duplicating retry classification.
 * @param error - The original API error.
 * @returns Whether authorized cached data must be hidden.
 */
export const isApiAuthorizationError = (error: unknown): boolean =>
  error instanceof ApiError &&
  (error.status === HTTP_STATUS_UNAUTHORIZED ||
    error.status === HTTP_STATUS_FORBIDDEN);
